import { SceneEditorAppWrapper } from "oc-scene-editor/ui/SceneEditorAppWrapper";
import { Cookiebanner, isCookieSupressed } from "./components/Cookiebanner";
import { Header } from "./components/Header";
import { SavingContextProvider } from "./hooks/UseSaving";
import Messages from "./commons/Messages";
import { SkipLink } from "./components/SkipLink";

export function Index() {
  const Page = APP.pageClass;
  const cookies = APP?.richMetadata?.getCookieData();
  const urlParams = new URLSearchParams(window.location.search);
  const isTest = urlParams.has("test");
  return (
    <>
      <SceneEditorAppWrapper sceneNode={APP.sceneNode} isAdmin={APP.settings.userRole == "admin"}>
        <SavingContextProvider>
          <div className="stage grid-fullscreen"></div>
          {Page && (
            <>
              <SkipLink focusFirstInteractive />
              <Header />
              <main id="main-content" style={{ display: "contents" }}>
                <Page
                  key={APP.pageShowCounter}
                  ref={(r) => {
                    if (r != null) {
                      APP.pageInstance = r as any;
                      APP.pageInstanceCounter++;
                    }
                  }}
                />
              </main>
            </>
          )}
        </SavingContextProvider>
      </SceneEditorAppWrapper>
      <Messages managerObject={APP} />
      {!isTest && cookies && !isCookieSupressed() && (
        <Cookiebanner cookies={cookies} storageKey={APP.cookieStorageKey} />
      )}
    </>
  );
}
